import React from "react";
import images from "assets/images";

import { FooterNavigation, SocialNavigation } from "components";

export const Footer = () => (
  <footer className="footer">
    <div className="wrapper">
      <div className="footer__layout">
        <div className="footer__branding">
          <img
            alt="Homepage"
            className="footer__logo"
            src={images.logoSymbol}
          />
        </div>
        <div className="footer__nav">
          <FooterNavigation />
        </div>
        <div className="footer__social">
          <SocialNavigation />
          <div className="footer__impressum u-spc-top--lrg">
            <p className="u-type--micro u-type--o30 u-spc-bottom--sml">
              Copyright @ viahub 2018
            </p>
            <p className="u-type--micro u-type--o30">All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx